/* eslint-disable max-len */
import React, { useEffect, useRef, useState } from 'react';
import styles from './styles.module.scss';

const AccordionItem = ({
  title, description, isOpen, onClick,
}: any) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  useEffect(() => {
    if (isOpen && contentRef.current) {
      setHeight(contentRef.current.scrollHeight);
    } else {
      setHeight(0);
    }
  }, [isOpen]);
  return (
    <div className={styles.item}>
      <button className={`${styles.title} ${isOpen ? styles.titleOpen : ''}`} onClick={onClick} type="button">
        {title}
        <span className={`${styles.icon} ${isOpen ? styles.open : ''}`} />
      </button>
      <div
        className={styles.contentWrapper}
        style={{ maxHeight: `${height}px` }}
      >
        <div className={styles.contentInner} ref={contentRef}>
          {/* <ReactMarkdown skipHtml={false}> */}
          {description}
          {/* </ReactMarkdown> */}
        </div>
      </div>
    </div>
  );
};

const Accordion = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index: any) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const items = [
    {
      title: '1. What is Represent?',
      description: (
        <>
          <p>
            <strong>
              Represent is a platform that gives people the power to vote, make
              decisions, and participate in real democracy from anywhere — safely,
              digitally, and transparently.
            </strong>
          </p>
          <br />
          <br />
          <p>
            It’s designed for towns, schools, movements, and communities that want
            to govern together — not wait on broken systems.
          </p>
        </>
      ),
    },
    {
      title: '2. How does Represent work?',
      description: (
        <>
          <p>Represent allows you to:</p>
          <ul>
            <li>Verify your identity (privately and securely)</li>
            <li>Join decision-making in your area or group</li>
            <li>Vote on proposals using tamper-proof technology</li>
          </ul>
          <p>
            It runs on a
            {' '}
            <strong>decentralized network</strong>
            , which means no one
            person, company, or government controls it.
          </p>
        </>
      ),
    },
    {
      title: '3. Do I need to understand crypto or blockchain to use Represent?',
      description: (
        <>
          <p><strong>Not at all.</strong></p>
          <p>
            Represent is built for regular people. If you can use an app or website,
            you can use Represent. The complex tech stays in the background.
          </p>
        </>
      ),
    },
    {
      title: '4. Who can use Represent?',
      description: (
        <>
          <p><strong>Anyone!</strong></p>
          <br />
          <p>Represent is made for:</p>
          <br />
          <ul>
            <li>Cities and towns</li>
            <li>Indigenous nations</li>
            <li>Schools and universities</li>
            <li>Nonprofits and grassroots movements</li>
            <li>Online communities and DAOs</li>
          </ul>
          <p>
            Whether you live in one of the world’s largest cities, or a small
            village, Represent helps your group
            {' '}
            <strong>self-govern with digital trust</strong>
            .
          </p>
        </>
      ),
    },
    {
      title: '5. What is a verified ID, and who controls it?',
      description: (
        <>
          <p>
            When you sign up for Represent, you can create a
            {' '}
            <strong>Verified ID</strong>
            {' '}
            that proves you’re a real, unique person — this is called an NFT Passport
          </p>
          <br />
          <br />
          <p>
            ✅
            {' '}
            <strong>You own your ID. No one — not even Represent — can change it, delete it, or use it for anything without your permission.</strong>
          </p>
          <br />
          <br />
          <p>
            This ID is yours alone, stored securely using encrypted, blockchain-based
            technology. This will allow you to participate in future blockchain
            applications and will allow you to prepare to protect yourself from
            centralized systems that would use technology to apply unwanted controls
            against you.
          </p>
        </>
      ),
    },
    {
      title: "6. What does 'decentralized' mean?",
      description: (
        <>
          <p>
            A
            {' '}
            <strong>decentralized network</strong>
            {' '}
            is not run by a company or government — it’s powered by the people who use it.
          </p>
          <br />
          <br />

          <p>
            Instead of one server or authority calling the shots, everyone who participates helps keep the system fair, secure, and running — no matter where in the world they are.
          </p>
        </>
      ),
    },
    {
      title: '7. What is geo-gated voting?',
      description: (
        <>
          <p>
            <strong>Geo-gated voting</strong>
            {' '}
            means only people in a specific location (like a city, campus, or community) can vote on decisions that affect that place.
          </p>
          <br />
          <br />
          <p>
            Represent uses privacy-safe tools to verify that you live in or belong to a
            certain area — without tracking your exact location. This keeps voting
            {' '}
            <strong>fair, local, and secure</strong>
            .
          </p>
        </>
      ),
    },
    {
      title: '8. How can I join and start participating?',
      description: (
        <ol>
          <li>
            Go to
            {' '}
            <a href="https://www.representvote.com" target="_blank" rel="noreferrer">www.representvote.com</a>
            {' '}
          </li>
          <li>Create your digital ID</li>
          <li>Prepare to join votes that match your location or community</li>
          <li>Propose ideas (coming soon)</li>
          <li>Help shape how your world works</li>
          <li>Participate in supervising all aspects of area governance</li>
        </ol>
      ),
    },
    {
      title: '9. How is Represent different from regular online voting or polls?',
      description: (
        <>
          <p>
            Most online polls are easy to fake — people can vote multiple times or
            manipulate the results. Represent is different.
          </p>
          <br />
          <br />
          <p>
            It uses
            {' '}
            <strong>blockchain</strong>
            , a kind of digital record book that:
          </p>
          <br />
          <ul>
            <li>Can’t be hacked or altered</li>
            <li>
              Makes sure every person gets only
              <strong>one secure vote</strong>
            </li>
            <li>Stores votes publicly but anonymously, so the process stays fair</li>
          </ul>
        </>
      ),
    },
    {
      title: '10. Can Represent be hacked?',
      description: (
        <>
          <p><strong>No — it is not like traditional voting systems.</strong></p>
          <p>
            Represent uses blockchain, which means once a vote is cast, it’s
            {' '}
            <strong>locked in permanently</strong>
            {' '}
            and can’t be changed or deleted.
          </p>
          <p>
            The system is verified by multiple computers around the world — not stored
            in one place that could be hacked.
          </p>
        </>
      ),
    },
    {
      title: '11. Is my personal data safe?',
      description: (
        <>
          <p>
            Yes. Represent never stores your private identity details like name, phone,
            or address. Your verified ID proves you&apos;re real — but
            {' '}
            <strong>only you control and own it</strong>
            .
          </p>
          <p>
            It’s encrypted, private, and designed to keep you safe while staying
            anonymous to the public.
          </p>
        </>
      ),
    },
    {
      title: '12. Is Represent free to use?',
      description: (
        <>
          <p>
            Everyone can use it — but it is a decentralized network (all users are owners)
            and fees are required to participate in the network to allow it to run.
          </p>
          <p>
            All users will pay to obtain their membership in their geography
            (an online verification called an NFT Passport which can be obtained at
            {' '}
            <a href="https://www.representid.com" target="_blank" rel="noreferrer">
              www.representid.com
            </a>
            {' '}
            and then a small fee per vote to facilitate online transactions).
          </p>
          <p>
            Typical fee structure would be $20 for first year (to obtain your NFT
            passport and participate in multiple votes) and then approximately $5 per
            year afterwards to vote as necessary.
          </p>
          <p>
            NFT passport is a one-time fee to verify in your geography, and voting is a
            small fee per vote.
          </p>
        </>
      ),
    },
    {
      title: '13. What’s the bigger vision for Represent?',
      description: (
        <>
          <p>
            Represent is here to make
            {' '}
            <strong>every voice count — anywhere in the world</strong>
            .
          </p>
          <p>
            Whether you live in a big city or a small town, go to school or run a DAO,
            you deserve tools to make decisions together.
          </p>
          <br />
          <br />
          <p>
            We believe
            {' '}
            <strong>you shouldn’t have to wait every 4 years or rely on politicians to make your voice heard</strong>
            . Represent gives people the tools to
            {' '}
            <strong>propose, vote, and decide — anytime, anywhere — together</strong>
            ;
            creating a future where people
            <strong>govern themselves — directly, fairly, and freely</strong>
            .
          </p>
          <br />
          <p>It’s real democracy, built for the digital age.</p>
          <br />
          <br />
          <p>
            Represent exists to protect you from foreign and domestic intrusion into your geography, using equal technological advances that could be used against you.  Sign up today!
          </p>
        </>
      ),
    },
  ];

  return (
    <div className={styles.accordion}>
      {items.map((item, index) => (
        <AccordionItem
          key={item.title}
          title={item.title}
          description={item.description}
          isOpen={openIndex === index}
          onClick={() => toggle(index)}
        />
      ))}
    </div>
  );
};

export default Accordion;
